/* eslint-disable @typescript-eslint/naming-convention */
export const CLEAR_SESSION = "CLEAR_SESSION";
type CLEAR_SESSION = typeof CLEAR_SESSION;

export const SET_SESSION = "SET_SESSION";
type SET_SESSION = typeof SET_SESSION;

export const SET_IS_AUTH_LOADING = "SET_IS_AUTH_LOADING";
type SET_IS_AUTH_LOADING = typeof SET_IS_AUTH_LOADING;

export type ClearSessionAction = {
  type: CLEAR_SESSION;
};
